var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseApiClient } from "./BaseApiClient";
export var MARKETS_ENDPOINTS = {
    BY_EVENT_ID: "/Markets/GetByEventId"
};
/**
 * MarketsApiClient - client for fetching Markets BFF endpoints
 * @export
 * @class MarketsApiClient
 * @extends {BaseApiClient}
 */
var MarketsApiClient = /** @class */ (function (_super) {
    __extends(MarketsApiClient, _super);
    function MarketsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch markets by id from BFF
     * @param {request} MarketsByEventIdRequest
     * @throws {RequiredError}
     * @memberof MarketsApiClient
     */
    MarketsApiClient.prototype.getByEventId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(MARKETS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    };
    return MarketsApiClient;
}(BaseApiClient));
export { MarketsApiClient };
//# sourceMappingURL=MarketsApiClient.js.map